let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hQ20i")).then(() => parcelRequire('h7JqD'));